import { EventMeta } from '../../../interfaces/meta.interface';

const searchQueryInitiated: EventMeta = {
    title: 'Search Query Initiated',
    default: {
        description: 'Search Query Initiated',
        longDescription:
            'User performed an Advanced Audit search in Exchange Online (E5 or E5 Compliance add-on subscription users only).',
        severity: 'info',
    },
};

export default searchQueryInitiated;
